import React, { useState } from 'react'
import styled from 'styled-components'
import Modal from '../modal'
import { RequestType } from './constants'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const SuccessIconWrapperElement = styled.div`
  width: 27rem;
  height: 5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
`

const UrlContentWrapperElement = styled.div`
  width: 35rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  padding: 0.5rem 0;
  gap: 1.5rem;
`

const SubtitleElement = styled.h6`
  font-size: 0.8rem !important;
  font-weight: 200 !important;
  margin: 0 !important;
`

const UrlContainerElement = styled.div`
  display: flex;
  height: 35px;
  width: 100%;
`

const DisabledInputElement = styled.input`
  border: 1px solid #dbdbdc;
  padding: 5px;
  height: 35px;
  box-sizing: border-box;
  background-color: #f5f5f5;
  flex: 1;
`

const CopyButtonElement = styled.button`
  cursor: pointer;
  color: white;
  width: 65px;
  border: none;
  height: 35px;
  display: block;
  background-color: #dc6a00;
`

const namesFormatter = new Intl.ListFormat('en', {
  style: 'long',
  type: 'conjunction',
})

function SuccessModal({
  handleClose,
  signatureRequests,
  guarantors,
  requestType,
}) {
  const [copied, setCopied] = useState(false)

  if (requestType === RequestType.EMAIL)
    return (
      <Modal
        title="Your signature request was sent successfully!"
        onClose={handleClose}
      >
        <SuccessIconWrapperElement>✔️</SuccessIconWrapperElement>
      </Modal>
    )

  if (signatureRequests.length === 0) return null

  const lastSignatureRequest = signatureRequests[signatureRequests.length - 1]

  const shareWith =
    lastSignatureRequest?.name ||
    namesFormatter.format(guarantors.map((g) => g.name))

  const url = lastSignatureRequest?.url || ''

  return (
    <Modal title="Share With Your Borrower" onClose={handleClose}>
      <UrlContentWrapperElement>
        <SubtitleElement>
          Share this link with {shareWith} to e-sign the document
        </SubtitleElement>
        <UrlContainerElement>
          <DisabledInputElement disabled value={url} />
          <CopyToClipboard onCopy={() => setCopied(true)} text={url}>
            <CopyButtonElement id="copy_url">
              {copied ? 'Copied' : 'Copy'}
            </CopyButtonElement>
          </CopyToClipboard>
        </UrlContainerElement>
      </UrlContentWrapperElement>
    </Modal>
  )
}

export default SuccessModal
